<template>
  <div class="main-wrapper">

    <div class="login-page">
      <div class="login-body container">
        <div class="loginbox">
          <div class="login-right-wrap">
            <div class="account-header">
              <div class="account-logo text-center mb-4">
                <router-link to="/">
                  <a href="/" class="text-lg" style="font-size: 26px">
                    <span 
                      class="font-weight-600 text-slate-300" 
                      :style="logoPrefixStyle"
                    >
                      {{ branding.logo.prefix }}
                    </span>
                    <span 
                      class="font-weight-bold text-slate-500"
                      :style="logoSuffixStyle"
                    >
                      {{ branding.logo.suffix }}
                    </span>
                  </a>
                </router-link>
              </div>
            </div>
            <div class="login-header text-center">
              <h6 class="text-muted">Register to continue</h6>
              <div class="mt-4">
                <div v-if="success === true && message" class="alert alert-success alert-dismissible fade show"
                     role="alert">
                  <strong>Success!</strong> {{ message }}
                  <button type="button" class="close" data-dismiss="alert" aria-label="Close" @click="resetMessage">
                    <span aria-hidden="true">×</span>
                  </button>
                </div>
                <div v-if="success === false && message" class="alert alert-danger alert-dismissible fade show"
                     role="alert">
                  {{ message }}
                  <button type="button" class="close" data-dismiss="alert" aria-label="Close" @click="resetMessage">
                    <span aria-hidden="true">×</span>
                  </button>
                </div>
              </div>
            </div>

            <form action="">
              <div class="form-group">
                <input
                  type="text"
                  class="form-control"
                  id="company.name"
                  required
                  v-model="company.name"
                  name="company.name"
                  placeholder="Business name"
                />
              </div>
              <div class="form-group">
                <input
                  type="text"
                  class="form-control"
                  id="email"
                  required
                  v-model="email"
                  name="email"
                  placeholder="Enter your email"
                />
              </div>
              <div class="form-group mb-4" style="position: relative;">
                <input
                  :type="showPassword ? 'text' : 'password'"
                  class="form-control"
                  id="password"
                  required
                  v-model="password"
                  name="password"
                  placeholder="Enter your password"
                />
                <button
                  class="btn"
                  style="position: absolute; top: 0; right: 0; margin-top: 2% !important;"
                  type="button"
                  @click="togglePassword($event)"
                >

                  <i v-if="showPassword" class="fa fa-eye mr-1"></i>
                  <i v-else class="fa fa-eye-slash mr-1"></i>
                </button>
              </div>
              <div class="text-center">
                <button 
                  class="btn btn-primary btn-block account-btn" 
                  @click="register($event)"
                  :style="{ 
                    backgroundColor: branding.buttonColor, 
                    color: branding.buttonTextColor, 
                    borderColor: branding.buttonColor 
                  }"
                >
                  Register
                </button>
                <button 
                  class="btn btn-primary btn-block account-btn mt-2" 
                  @click="login($event)"
                  :style="{ 
                    backgroundColor: 'white', 
                    color: branding.buttonColor, 
                    borderColor: branding.buttonColor 
                  }"
                >
                  Login
                </button>
              </div>
            </form>
            <!--								<div class="login-or">-->
            <!--									<span class="or-line"></span>-->
            <!--									<span class="span-or">or</span>-->
            <!--								</div>-->
            <!--								<div class="text-center dont-have">Already have a store? <router-link to="/login">Login</router-link></div>-->
            <div class="text-center dont-have">
              <div>
                <small id="terms-footnote" class="footnote">
                  {{ branding.footerText }} 
                  <a 
                    :href="branding.privacyPolicyUrl" 
                    target="_blank" 
                    :style="{ color: branding.primaryColor }"
                  >
                    privacy policy
                  </a> 
                  and 
                  <a 
                    :href="branding.termsUrl" 
                    target="_blank" 
                    :style="{ color: branding.primaryColor }"
                  >
                    terms and conditions
                  </a> 
                  that govern your usage of our services.
                </small>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import authServiceApi from "../../service/AuthServiceApi.js"
import { getBrandingByDomain } from "@/config/domainBranding";

export default {
  name: "register-user",
  data() {
    return {
      success: null,
      message: "",
      email: "",
      password: "",
      company: {
        name: "",
      },
      userId: null,
      companyId: null,
      adminUser: true,
      store: null,
      warehouse: null,
      showPassword: false,
      branding: getBrandingByDomain(location.host)
    };
  },
  computed: {
    logoSuffixStyle() {
      return {
        color: this.branding.logo.suffixColor || '#ffffff',
        fontWeight: 'bold',
        backgroundColor: this.branding.logo.suffixBackgroundColor || this.branding.primaryColor,
        padding: '6px',
        borderRadius: '5px'
      }
    },
    logoPrefixStyle() {
      return {
        color: this.branding.logo.prefixColor || this.branding.secondaryColor
      }
    }
  },
  methods: {
    togglePassword(e) {
      e.preventDefault();
      this.showPassword = !this.showPassword
    },
    login() {
      this.$router.push('/login');
    },
    register(e) {
      e.preventDefault();
      if (!this.password || this.password.trim() === "") {
        this.success = false
        this.message = 'Please enter your password'
        return
      }
      let loader = this.$loading.show({
        container: this.fullPage ? null : this.$refs.formContainer,
        canCancel: false,
        onCancel: this.onCancel,
      });
      let data = {
        email: this.email,
        password: this.password,
        businessName: this.company.name,
        domain: location.host,
        locale: Intl.NumberFormat().resolvedOptions().locale
      };
      
      // Add signup plan and type from route query parameters if available
      if (this.$route.query.signup_plan) {
        data.signupPlan = this.$route.query.signup_plan;
      }
      if (this.$route.query.signup_type) {
        data.signupType = this.$route.query.signup_type;
      }
      
      authServiceApi.register(data)
        .then(response => {
          let success = response.data.success;
          if (success) {
            this.success = true
            this.message = response.data.narrative
            localStorage.setItem("showFreebiesPopUp", "true")
            this.resetMessage()
            this.$router.push("/register/confirm")
          } else {
            this.success = false
            this.message = response.data.narrative
          }
        })
        .catch(e => {
          console.log(">>> Error: ", e)
          if (e.response && e.response.status) {
            if (e.response.status === 400 || e.response.status === 401 || e.response.status === 403 || e.response.status === 409) {
              this.success = false
              this.message = e.response.data.narrative
              return
            }
          }
          this.success = false
          this.message = "An error occurred"
        }).finally(() => {
        loader.hide()
      })
    },
    resetMessage() {
      this.message = ""
      this.company = {}
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/auth/Register.vue